<div class="d-flex justify-content-center">
  <div class="head-pictogram">
    <div class="pictogram" [class]="animateClass">
      <svg class="icon-lg text-secondary">
        <use [attr.href]="'#' + icon" />
      </svg>
    </div>
    <p *ngIf="label" class="text-center">{{ label | translate }}</p>
  </div>
</div>